import { render, staticRenderFns } from "./service-planning.vue?vue&type=template&id=561e8a2e"
import script from "./service-planning.vue?vue&type=script&lang=js"
export * from "./service-planning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports